import create from 'zustand'
import { UseFormReturn } from 'react-hook-form'

import { LocaleDto } from '../../../types'
import { SettingModalStoreState, SettingsFormFields } from './types'

export const useSettingsModalStore = create<SettingModalStoreState>((set) => ({
  locales: [],
  isModalOpened: false,
  settingsForm: null,

  setLocales: (locales: LocaleDto[]) => set({ locales }),
  toggleModal: (isModalOpened: boolean) => set({ isModalOpened }),
  setSettingsForm: (settingsForm: UseFormReturn<SettingsFormFields> | null) => set({ settingsForm }),
}))
